__webpack_require__.p = "https://cdn.dgtalguide.com/web/bundles/0708906/";